// GeoStock Inventory Location Handler
(function() {
  'use strict';

  function fetchGeoStockInventory(inventoryDiv) {
    const variantId = inventoryDiv.dataset.variantId;
    const isB2BApproved = inventoryDiv.dataset.isB2bApproved === 'true';
    const inStock = inventoryDiv.dataset.inStock === 'true';
    const shopDomain = inventoryDiv.dataset.shopDomain;

    if (!variantId || !shopDomain) {
      console.warn('GeoStock: Missing required data attributes', { variantId, shopDomain });
      inventoryDiv.innerHTML = '<span class="product__inventory">Unable to load inventory</span>';
      return;
    }

    // Show loading state
    inventoryDiv.innerHTML = '<span class="inventoryLocationLoading">Loading inventory...</span>';

    // Build API URL
    const apiUrl = `https://api.geostock.app/shop/${shopDomain}/variant_locations/${variantId}?lat=null&lon=null`;

    // Fetch GeoStock data
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
      credentials: 'omit'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('GeoStock API Response:', data);
        
        if (!data || !data.locations || data.locations.length === 0) {
          inventoryDiv.innerHTML = '<span class="product__inventory">Out of Stock</span>';
          return;
        }

        let html = '';
        // Only show locations enabled in GeoStock admin
        const locations = data.locations.filter(location => {
          if (!location.enabled) {
            return false;
          }
          // Special case: "Other" location should only show if it has stock > 0
          if (location.name === 'Other' && location.stock <= 0) {
            return false;
          }
          return true;
        });

        if (locations.length === 0) {
          inventoryDiv.innerHTML = '<span class="product__inventory">Out of Stock</span>';
          return;
        }

        // Scenario 1: B2B + In Stock
        if (isB2BApproved && inStock) {
          locations.forEach((location, index) => {
            const stockCount = location.stock || 0;
            const status = stockCount > 0 ? stockCount : 'Out of Stock';
            const statusColor = stockCount > 0 ? '#5cb85c' : '#d9534f';
            html += `<span class="product__inventory"><span style="color: #333333; font-weight: 600;">${location.name}</span> : <span style="color: #000000;">${status}</span></span>`;
            if (index < locations.length - 1) {
              html += ' ';
            }
          });
        }
        // Scenario 2 & 4: B2B + Out of Stock OR Not B2B + Out of Stock
        else if (!inStock) {
          locations.forEach((location, index) => {
            html += `<span class="product__inventory"><span style="color: #333333; font-weight: 600;">${location.name}</span> : <span style="color: #000000;">Out of Stock</span></span>`;
            if (index < locations.length - 1) {
              html += ' ';
            }
          });
        }
        // Scenario 3: Not B2B + In Stock
        else if (!isB2BApproved && inStock) {
          locations.forEach((location, index) => {
            const stockCount = location.stock || 0;
            const status = stockCount > 0 ? 'In Stock' : 'Out of Stock';
            const statusColor = stockCount > 0 ? '#5cb85c' : '#d9534f';
            html += `<span class="product__inventory"><span style="color: #333333; font-weight: 600;">${location.name}</span> : <span style="color: #000000;">${status}</span></span>`;
            if (index < locations.length - 1) {
              html += ' ';
            }
          });
        }

        inventoryDiv.innerHTML = html || '<span class="product__inventory">No inventory locations found</span>';
      })
      .catch(error => {
        console.error('GeoStock API Error:', error);
        inventoryDiv.innerHTML = '<span class="product__inventory">Unable to load inventory</span>';
      });
  }

  function initGeoStockInventory() {
    const inventoryDiv = document.getElementById('inventoryLocationInformation');
    if (inventoryDiv) {
      fetchGeoStockInventory(inventoryDiv);
    }
  }

  function updateInventoryOnVariantChange(event) {
    const inventoryDiv = document.getElementById('inventoryLocationInformation');
    if (!inventoryDiv) return;

    const variant = event.detail?.variant;
    if (variant && variant.id) {
      inventoryDiv.dataset.variantId = variant.id;
      
      // Recalculate stock status for new variant
      const inStock = variant.available !== false && 
                     (variant.inventory_quantity === null || variant.inventory_quantity > 0);
      inventoryDiv.dataset.inStock = inStock ? 'true' : 'false';
      
      fetchGeoStockInventory(inventoryDiv);
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGeoStockInventory);
  } else {
    initGeoStockInventory();
  }

  // Listen for variant changes
  document.addEventListener('variant:changed', updateInventoryOnVariantChange);

  // Also listen to the pubsub event if available
  if (window.FoxTheme && window.FoxTheme.pubsub) {
    window.FoxTheme.pubsub.subscribe(
      window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
      function(event) {
        const variant = event.data?.variant;
        if (variant) {
          updateInventoryOnVariantChange({ detail: { variant } });
        }
      }
    );
  }

  // Handle dynamic content updates (for AJAX page loads)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          const inventoryDiv = node.id === 'inventoryLocationInformation' 
            ? node 
            : (node.querySelector && node.querySelector('#inventoryLocationInformation'));
          
          if (inventoryDiv && !inventoryDiv.dataset.initialized) {
            inventoryDiv.dataset.initialized = 'true';
            fetchGeoStockInventory(inventoryDiv);
          }
        }
      });
    });
  });

  // Start observing when DOM is ready
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();
